export class Item {
  public Id: string;
  public Quantity: number;
  public Name: string;
  public Price: number;
}

export class PaymentIntentCreateRequest {
  public Items: Array<Item>
}

export class Amount {
  public AmountValue: number;
}

export class ClientSecretModel extends Amount {
  public Id: string;
  public ClientSecret: string;
  public PublicKeyStripe: string;
}

export class WalletInfo {
  public IdClient: string;
  public WalletAmount: number;
  public IdTransaction: string;
}
